import React from "react";
import "./WhatWillYou.css";
import TeslaLogo from "../assets/images/companies01.png";
import MercedesLogo from "../assets/images/companies02.png";
import DucatiLogo from "../assets/images/companies03.png";
import LamborghiniLogo from "../assets/images/companies04.png";
import ScanlaLogo from "../assets/images/companies05.png";
import ScanlaLogo01 from "../assets/images/companies06.png";
import ScanlaLogo02 from "../assets/images/companies07.png";
import ScanlaLogo03 from "../assets/images/companies08.png";
import ScanlaLogo04 from "../assets/images/companies09.png";
import ScanlaLogo05 from "../assets/images/companies10.png";

const WhatWillYou = () => {
  const logos = [TeslaLogo, MercedesLogo, DucatiLogo, LamborghiniLogo, ScanlaLogo, ScanlaLogo01, ScanlaLogo02, ScanlaLogo03, ScanlaLogo04, ScanlaLogo05];

  return (
    <div className="WhatWillYou__container">
      <div className="training-content">
        <div className="trusted-title">Trusted by <strong>40+ Companies</strong></div>
        <div className="training-text-bar">
          <div className="doubt-content-bar">
            <div className="marquee-wrapper">
              <div className="marquee-content">
                {logos.map((logo, idx) => (
                  <div key={idx} className="doubt-text">
                    <img src={logo} alt="" />
                  </div>
                ))}
                {logos.map((logo, idx) => (
                  <div key={`dup-${idx}`} className="doubt-text">
                    <img src={logo} alt="" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatWillYou;